import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getOnboardingServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

export const GET_ALL_ONBOARDING_AML_SCORES = 'GET_ALL_ONBOARDING_AML_SCORES';
export const GET_ONBOARDING_AML_SCORE_BY_ID = 'GET_ONBOARDING_AML_SCORE_BY_ID';

export const onboardingAMLScoreApiDefaultConfig = {
  retry: undefined,
};

export const useOnboardingAMLScoreApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...onboardingAMLScoreApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getOnboardingServerErrorMessage(error));
      logError(error, 'Error while calling onboarding AML score api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
